import React from 'react'

import {
    useHistory
} from "react-router-dom"

import { 
    useForm 
} from 'react-hook-form'

import { 
    Auth 
} from 'aws-amplify'

import { 
    ErrorText,
    BlueTint 
} from '../../Styles/BaseStyles'

import { 
    ResetPasswordDiv, 
    ResetPasswordComponentsDiv, 
    ResetPasswordFieldsDiv,
    QuickFillerButtonDiv,
    QuickFillerButton,
    ResetPasswordTitle, 
    ResetPasswordFormDiv, 
    ResetPasswordInputField, 
    ResetPasswordButtonDiv, 
    ResetPasswordButton
} from '../../Styles/Components/ResetPasswordFieldsStyles'

import { useDispatch } from 'react-redux'

import { passwordResetConfirm, passwordResetError } from '../../Redux/Slices/ResetPasswordSlice'

function ResetPasswordFields(props){
    const { register, errors, watch, handleSubmit } = useForm({
        validateCriteriaMode: "all",
        mode: "onChange"
    })

    const watchPassword = watch("password","")
    const watchCPassword = watch("cpassword","")

    const dispatch = useDispatch()

    let history = useHistory()

    let email = props.username
    let code = props.code

    function mainPage(e){
        history.push('/')
    }
    
    function formActions(data){
        resetPassword(data);
    }

    async function resetPassword(data) {
        var newPswd = data.password;

        try {
            await Auth.forgotPasswordSubmit(email, code, newPswd)
            dispatch(passwordResetConfirm())
        } catch (error) {
            switch(error.code){
                default:
                    dispatch(passwordResetError({errorPhrase: 'Encountered an error during password reset'}))
                    break
            }  
        }
    }

    return (
        <ResetPasswordDiv id="signup-section">
            <ResetPasswordComponentsDiv>
                <ResetPasswordFieldsDiv>
                    <QuickFillerButtonDiv>
                        <QuickFillerButton onClick={mainPage}><BlueTint>Q</BlueTint>uick<BlueTint>F</BlueTint>iller</QuickFillerButton>
                    </QuickFillerButtonDiv>
                    <ResetPasswordTitle>Reset Password</ResetPasswordTitle>
                    <ResetPasswordFormDiv>
                        <form>
                            <ResetPasswordInputField 
                                type="password" name="password" placeholder="password" 
                                ref={
                                    register({ 
                                        required: {
                                            value: true,
                                            message: 'password is required'
                                        },
                                        pattern: {
                                            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                            message: 'password must contain at least 8 characters, an uppercase letter, an lowercase letter, a number, and a special character'
                                        } 
                                    })
                                }
                            /><br/>
                            {errors.password && <ErrorText>*{errors.password.message}</ErrorText>}
                            <ResetPasswordInputField 
                                type="password" name="cpassword" placeholder="confirm password" 
                                ref={
                                    register({ 
                                        required: true, 
                                        minLength: 8, 
                                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/ 
                                    })  
                                }
                            /><br/>
                            {!(watchPassword===watchCPassword) && <ErrorText>*must match password</ErrorText>}
                            <ResetPasswordButtonDiv>
                                <ResetPasswordButton onClick={handleSubmit(formActions)}>Reset Password</ResetPasswordButton>
                            </ResetPasswordButtonDiv>
                        </form>
                    </ResetPasswordFormDiv>
                </ResetPasswordFieldsDiv>
            </ResetPasswordComponentsDiv>
        </ResetPasswordDiv>
    )
}

export default ResetPasswordFields